import { s as script } from './Field-CMd66v8h.js';
import { u as use, a as registerComponent } from './plugins-1raZX6c5.js';
import './config-nHWiBviw.js';
import './helpers-O9h6_ICO.js';
import './typeof-Z4rCTFCZ.js';
import 'vue';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, script);
  }
};
use(Plugin);

export { script as BField, Plugin as default };
